'use client'

import { FC } from 'react'

interface IconProps {
className?: string
size?: number
}

// Icône mariée pixel art moderne
export const BrideIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Voile */}
	<path
	d="M12 2C10 2 8.5 3 8 4.5L6 8H18L16 4.5C15.5 3 14 2 12 2Z"
	fill="currentColor"
	opacity="0.3"
	/>
	{/* Visage */}
	<circle cx="12" cy="10" r="3.5" fill="#FDBCB4" />
	{/* Cheveux */}
	<path
	d="M9 8C9 6.5 10.5 5 12 5C13.5 5 15 6.5 15 8V10H9V8Z"
	fill="#F4D03F"
	/>
	{/* Robe */}
	<path
	d="M8 14L10 22H14L16 14C16 13 15 12.5 12 12.5C9 12.5 8 13 8 14Z"
	fill="white"
	stroke="currentColor"
	strokeWidth="0.5"
	/>
	{/* Détails robe */}
	<circle cx="10.5" cy="16" r="0.5" fill="currentColor" opacity="0.2" />
	<circle cx="13.5" cy="18" r="0.5" fill="currentColor" opacity="0.2" />
	{/* Yeux */}
	<circle cx="10.5" cy="9.5" r="0.3" fill="#2C3E50" />
	<circle cx="13.5" cy="9.5" r="0.3" fill="#2C3E50" />
	{/* Sourire */}
	<path d="M10.5 11C11 11.5 13 11.5 13.5 11" stroke="#2C3E50" strokeWidth="0.3" fill="none" />
</svg>
)

// Icône marié pixel art moderne
export const GroomIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Visage */}
	<circle cx="12" cy="10" r="3.5" fill="#FDBCB4" />
	{/* Cheveux */}
	<path
	d="M9 8C9 6.5 10.5 5 12 5C13.5 5 15 6.5 15 8V9H9V8Z"
	fill="#F4D03F"
	/>
	{/* Costume */}
	<path
	d="M8 14L10 22H14L16 14C16 13 15 12.5 12 12.5C9 12.5 8 13 8 14Z"
	fill="#2C3E50"
	/>
	{/* Chemise */}
	<rect x="10.5" y="12.5" width="3" height="9.5" fill="white" />
	{/* Noeud papillon */}
	<path
	d="M10.5 13.5H13.5L12 14.5L13.5 15.5H10.5L12 14.5Z"
	fill="#8B0000"
	/>
	{/* Boutons */}
	<circle cx="12" cy="16" r="0.3" fill="#2C3E50" />
	<circle cx="12" cy="18" r="0.3" fill="#2C3E50" />
	{/* Yeux */}
	<circle cx="10.5" cy="9.5" r="0.3" fill="#2C3E50" />
	<circle cx="13.5" cy="9.5" r="0.3" fill="#2C3E50" />
	{/* Sourire */}
	<path d="M10.5 11C11 11.5 13 11.5 13.5 11" stroke="#2C3E50" strokeWidth="0.3" fill="none" />
</svg>
)

// Icône cœur pixel art
export const PixelHeartIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	<path
	d="M12 21L10.55 19.7C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 19.7L12 21Z"
	fill="currentColor"
	/>
	{/* Effet pixel */}
	<rect x="7" y="7" width="2" height="2" fill="white" opacity="0.3" />
	<rect x="15" y="7" width="2" height="2" fill="white" opacity="0.3" />
</svg>
)

// Icône gamepad retro
export const RetroGamepadIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Corps de la manette */}
	<path
	d="M7 9C5 9 3 11 3 13V15C3 17 5 19 7 19H8L10 17V11H14V17L16 19H17C19 19 21 17 21 15V13C21 11 19 9 17 9H7Z"
	fill="currentColor"
	/>
	{/* Croix directionnelle */}
	<rect x="6.5" y="12" width="3" height="1" fill="white" />
	<rect x="7.5" y="11" width="1" height="3" fill="white" />
	{/* Boutons A/B */}
	<circle cx="17" cy="12" r="1" fill="white" />
	<circle cx="18.5" cy="13.5" r="1" fill="white" />
	{/* Écran/détails */}
	<rect x="10.5" y="11.5" width="3" height="2" rx="0.5" fill="white" opacity="0.7" />
</svg>
)

// Icône message d'amour
export const LoveMessageIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Bulle de message */}
	<path
	d="M20 2H4C3 2 2 3 2 4V16C2 17 3 18 4 18H6L8 22L10 18H20C21 18 22 17 22 16V4C22 3 21 2 20 2Z"
	fill="currentColor"
	/>
	{/* Coeur dans le message */}
	<path
	d="M12 14L10.5 12.7C8.3 10.8 7 9.7 7 8.3C7 7.2 7.8 6.4 8.9 6.4C9.5 6.4 10.1 6.7 10.4 7.1H13.6C13.9 6.7 14.5 6.4 15.1 6.4C16.2 6.4 17 7.2 17 8.3C17 9.7 15.7 10.8 13.5 12.7L12 14Z"
	fill="white"
	/>
</svg>
)

// Icône trophée pixel
export const PixelTrophyIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Base */}
	<rect x="8" y="19" width="8" height="3" fill="currentColor" />
	{/* Tige */}
	<rect x="11" y="16" width="2" height="3" fill="currentColor" />
	{/* Coupe principale */}
	<path
	d="M8 4V14C8 15 9 16 10 16H14C15 16 16 15 16 14V4H8Z"
	fill="currentColor"
	/>
	{/* Anses */}
	<path d="M6 8V10C6 11 7 12 8 12" stroke="currentColor" strokeWidth="1.5" fill="none" />
	<path d="M18 8V10C18 11 17 12 16 12" stroke="currentColor" strokeWidth="1.5" fill="none" />
	{/* Détails pixel */}
	<rect x="10" y="6" width="4" height="1" fill="white" opacity="0.5" />
	<rect x="10" y="8" width="2" height="1" fill="white" opacity="0.3" />
	<rect x="12" y="10" width="2" height="1" fill="white" opacity="0.3" />
</svg>
)

// Icône utilisateurs géométrique
export const ModernUsersIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Première personne */}
	<circle cx="9" cy="8" r="3" fill="currentColor" opacity="0.8" />
	<path d="M15 20C15 16.7 12.3 14 9 14C5.7 14 3 16.7 3 20H15Z" fill="currentColor" opacity="0.8" />
	{/* Deuxième personne */}
	<circle cx="16" cy="7" r="2.5" fill="currentColor" />
	<path d="M21 19C21 16.2 18.8 14 16 14C15.2 14 14.5 14.2 13.9 14.5C14.6 15.7 15 17.3 15 19H21Z" fill="currentColor" />
</svg>
)

// Icône étoile magique
export const MagicStarIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Étoile principale */}
	<path
	d="M12 2L14.5 8.5L22 11L14.5 13.5L12 20L9.5 13.5L2 11L9.5 8.5L12 2Z"
	fill="currentColor"
	/>
	{/* Petites étoiles */}
	<circle cx="18" cy="6" r="1" fill="currentColor" opacity="0.6" />
	<circle cx="6" cy="18" r="1" fill="currentColor" opacity="0.6" />
	<circle cx="20" cy="18" r="0.5" fill="currentColor" opacity="0.4" />
	{/* Brillance */}
	<path d="M12 5L12.5 7.5L15 8L12.5 8.5L12 11L11.5 8.5L9 8L11.5 7.5L12 5Z" fill="white" opacity="0.7" />
</svg>
)

// Icône enveloppe avec cœur
export const LoveEnvelopeIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	{/* Enveloppe */}
	<path
	d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z"
	fill="currentColor"
	/>
	{/* Rabat */}
	<path d="M2 6L12 12L22 6" stroke="white" strokeWidth="1.5" fill="none" />
	{/* Cœur sur l'enveloppe */}
	<path
	d="M12 15L10.5 13.7C9.6 12.9 9 12.3 9 11.5C9 10.8 9.5 10.3 10.2 10.3C10.6 10.3 11 10.5 11.2 10.8H12.8C13 10.5 13.4 10.3 13.8 10.3C14.5 10.3 15 10.8 15 11.5C15 12.3 14.4 12.9 13.5 13.7L12 15Z"
	fill="white"
	/>
</svg>
)

// Icône dashboard moderne
export const ModernDashboardIcon: FC<IconProps> = ({ className = '', size = 24 }) => (
<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill="none"
	className={className}
>
	<rect x="3" y="3" width="7" height="7" rx="1" fill="currentColor" opacity="0.8" />
	<rect x="14" y="3" width="7" height="5" rx="1" fill="currentColor" />
	<rect x="14" y="12" width="7" height="9" rx="1" fill="currentColor" opacity="0.6" />
	<rect x="3" y="14" width="7" height="7" rx="1" fill="currentColor" opacity="0.9" />
	{/* Petits détails */}
	<circle cx="6.5" cy="6.5" r="1" fill="white" opacity="0.7" />
	<rect x="16" y="5" width="3" height="1" rx="0.5" fill="white" opacity="0.7" />
	<rect x="5" y="16" width="3" height="1" rx="0.5" fill="white" opacity="0.7" />
	<circle cx="17.5" cy="15.5" r="1" fill="white" opacity="0.7" />
</svg>
)

export default {
BrideIcon,
GroomIcon,
PixelHeartIcon,
RetroGamepadIcon,
LoveMessageIcon,
PixelTrophyIcon,
ModernUsersIcon,
MagicStarIcon,
LoveEnvelopeIcon,
ModernDashboardIcon
}
